import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLicense } from '../context/LicenseContext';
import ROUTE_MODULES from '../utils/routeModules';
import NotFound from '../pages/NotFound';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const { isModuleEnabled } = useLicense();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    return <Navigate to="/login" />;
  }

  const requiredModule = ROUTE_MODULES[location.pathname];
  if (requiredModule && !isModuleEnabled(requiredModule)) {
    return <NotFound />;
  }

  return children;
};

export default PrivateRoute;